export class DocumentResponseModel {
    constructor(
      public id: string,
      public documentTypeId: number,
      public documentId : string,
      public documentDescription : string,
      public documentName : string,
      public documentType : string,
      public documentData : string
    ) {}
  }
